@if (vm$ | async; as vm) {
  @if (!vm.readOnly) {
    <question-video-player-controls
      [canDelete]="vm.canDelete"
      [canRecord]="vm.canRecord"
      (startRecording)="startRecording()"
      (stopRecording)="stopRecording()"
      (pauseRecording)="pauseRecording()"
      (resumeRecording)="resumeRecording()"
      (removeRecording)="removeRecording()"
    ></question-video-player-controls>
  }
  @if (vm.showVideo) {
    <video
      [id]="vm.id"
      width="100%"
      [class]="vm.videoClass"
      [attr.data-qa]="vm.qaHook"
      controls
      playsinline
    ></video>
  }
  @if (vm.showHint) {
    <div class="max-length-hint">{{ vm.translations?.maximumLengthHint }}</div>
  }
  @if (loading()) {
    <jui-skeleton-loader
      color="info"
      inline="true"
      height="50px"
      width="100%"
      class="video-player-loading"
    ></jui-skeleton-loader>
  }
}
